import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { WARNING_TRIANGLE_ICON } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";
import Flex from "../../Generic/Flex";
import { If } from "../../Generic/If";
import { isDefined } from "../../Generic/IsDefined";
import SignatureBox from "../../SignatureBox/SignatureBox";
import { Slide, SlideInformationText, SlideProps, SlideStepLabel, SlideTitle } from "./Slide";

export const Slide5FinalConfirmation = (props: SlideProps) => {
  const { isBigScreen, onSignatureConfirmed } = props;

  return (
    <Slide>
      <If condition={props.showSteps}>
        <SlideStepLabel {...props} />
      </If>
      <SlideTitle>{translate(STRINGS.FINAL_CONFIRMATION)}</SlideTitle>
      <SlideInformationText>
        <span>{translate(STRINGS.REQUIREMENTS)}:&nbsp;</span>
        <b>{translate(STRINGS.YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT)}</b>
      </SlideInformationText>
      <SignatureBoxContainer className={isBigScreen ? "big" : undefined}>
        <SignatureBoxText>{translate(STRINGS.ADD_YOUR_SIGNATURE)}</SignatureBoxText>
        <SignatureBox
          placeholder={translate(STRINGS.SIGN_HERE)}
          onSubmit={(data) => onSignatureConfirmed(isDefined(data))}
        />

        <Flex className="WarningNotice" xGap={8}>
          <div>
            <AppIcon icon={WARNING_TRIANGLE_ICON} fill={"#F05757"} size={20} />
          </div>
          <div>
            {translate(
              STRINGS.SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES
            )}
          </div>
        </Flex>
      </SignatureBoxContainer>
    </Slide>
  );
};

const SignatureBoxText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 120%;
`;

const SignatureBoxContainer = styled.div`
  margin-top: 20px;

  .SignatureBox {
    margin-top: 12px;
  }

  &.big {
    .SignatureBox .click-area {
      height: 260px;
    }
  }

  .WarningNotice {
    color: #53606c;
    background: #fef2f2;
    border-radius: 8px;

    padding: 10px 8px;
    margin: 16px 0;

    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
  }
`;
